module.exports = __webpack_public_path__ + "static/media/lose.6d7bc8ba.png";